export default __webpack_public_path__ + "minus-sign-on-a-square-outline.png";